import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/layout/Navigation';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { TrialPage } from './pages/TrialPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { SchedulePage } from './pages/SchedulePage';
import { StaffPage } from './pages/StaffPage';
import { GalleryPage } from './pages/GalleryPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
// Scroll to top component
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="flex flex-col min-h-screen" data-id="element-2">
        <Navigation data-id="element-3" />
        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/trial" element={<TrialPage data-id="element-9" />} data-id="element-8" />
            <Route path="/programs" element={<ProgramsPage data-id="element-11" />} data-id="element-10" />
            <Route path="/schedule" element={<SchedulePage data-id="element-13" />} data-id="element-12" />
            <Route path="/staff" element={<StaffPage data-id="element-15" />} data-id="element-14" />
            <Route path="/gallery" element={<GalleryPage data-id="element-17" />} data-id="element-16" />
            <Route path="/about" element={<AboutPage data-id="element-19" />} data-id="element-18" />
            <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
          </Routes>
        </div>
        <Footer data-id="element-22" />
      </div>
    </BrowserRouter>;
}